import { Box, BoxProps, Heading } from "@chakra-ui/react";
import * as React from "react";
import { PostView, PostViewProps } from "./layout";

export interface ArticleSectionProps extends BoxProps, PostViewProps {
  title: string;
}
export const ArticleSection: React.FC<ArticleSectionProps> = ({
  posts,
  title,
  ...rest
}) => {
  return (
    <Box as="section" pb="20">
      <Box pt="20" pb="20" {...rest}>
        <Box
          maxW={{ base: "xl", md: "7xl" }}
          mx="auto"
          px={{ base: "6", md: "8" }}
        >
          <Box mb="16" maxW="2xl">
            <Heading
              size="xl"
              letterSpacing="tight"
              fontWeight="bold"
              lineHeight="normal"
              id={title.toLowerCase().replace(/\s/g, "-")}
            >
              {title}
            </Heading>
          </Box>
        </Box>
      </Box>
      <Box mt="-24">
        <Box
          maxW={{ base: "xl", md: "7xl" }}
          mx="auto"
          px={{ base: "6", md: "8" }}
        >
          <PostView posts={posts} tag />
        </Box>
      </Box>
    </Box>
  );
};
